const messages = {
  titleColorRev: "true",
  buttons: {
    pending: "V čakanju",
    open: "Odpri",
    requestAccess: "Zahtevaj dostop",
  },
  myBsApps: '<span class="text-danger">Moje aplikacije</span> Bridgestone',
  my: "Moje aplikacije",
  directRoute: "Vaše direktne povezave do Bridgestone spletnih aplikacij.",
  welcomeMessage:
    'Dobrodošli v BRIDGESTONE PLUS <span class="text-danger">PLUS</span>, %{first_name} %{last_name}',
  showProfile: "Prikaži profil",
  newMessages: "Novo sporočilo v prejeti pošti",
  myApps: "Moje aplikacije",
  allApps: "Vse aplikacije",
  myAppsDescription: "Vse Bridgestone spletne aplikacije, za katere ste registrirani.",
  allAppsDescription:
    "Vse Bridgestone spletne aplikacije, ki bi vas lahko zanimale.",
  myProfile: {
    welcomeMessage:
      "Dobrodošli v vaš osebni prostor. Tu lahko posodobite ali prilagodite vaše informacije in pregledate vašo prejeto pošto.",
    masterData: "Osnovni podatki",
    completeDetails:
      "Izpolnite vaše osebne in podatke o podjetju za zagotovitev pravilne registracije.",
    goToMasterData: "Pojdi na moje podatke",
    goToInbox: "Pojdi na prejeto pošto",
  },
  masterData: {
    welcomeMessage:
      "Dobrodošli v vaš osebni prostor. Tu lahko posodobite ali prilagodite vaše osnovne podatke.",
    personalDetails: "Osebni podatki",
    companyDetails: "Podatki o podjetju",
    emailAddress: "E-naslov",
    title: "Naziv",
    surname: "Priimek",
    firstName: "Ime",
    jobPosition: "Delovna pozicija",
    streetAndHouseNumber: "Naslov podjetja",
    postalCode: "Poštna številka",
    city: "Mesto",
    country: "Država",
    legalStructure: "Pravna struktura",
    customerNumber: "Bridgestone številka stranke",
    importantPleaseRead: "Pomembno, prosimo preberite",
    customerNumberInfo:
      "Za pravilno dodeljevanje vaših naročil pnevmatik različnim trgovcem je pomembno, da navedete vašo številko stranke.",
    multipleCustomerNumbers:
      "Če imate več številk strank pri trgovcu, npr. za vaše glavno podjetje in podružnice, prosimo najprej navedite številko stranke glavnega podjetja.",
    salesAssignment:
      "Prodaja, povezana z dodatnimi številkami strank, bo dodeljena vašemu glavnemu podjetju.",
    supplier: "Dobavitelj",
    addAnotherCustomerNumber: "Dodaj številko stranke",
    save: "Shrani",
    delete: "Izbriši",
  },
  inbox: {
    welcomeMessage: "Tu lahko najdete obvestila in pomembne novice.",
    sender: "Pošiljatelj",
    subject: "Zadeva",
    date: "Datum",
    formConsulting: "Obrazec prejet - Hvala za izpolnitev vašega profila.",
    back: "Nazaj",
  },
  legalAndContact: {
    cookieSettings: "Nastavitve piškotkov",
    dataPolicy: "Pravilnik o podatkih",
    termsOfUse: "Pogoji uporabe",
    helpAndContact: "Pomoč in kontakt",
  },
  logInSignUp: {
    logIn: "Prijavi se",
    signUp: "Registriraj se",
    logInMessage: "Prijavite se z vašim e-naslovom in geslom.",
    signUpMessage: "Če ste nov uporabnik, prosimo registrirajte se.",
  },
};

export default {
  messages,
};
